// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

const rootCauseAnalysis = {
  namespaced: true,
  state: {
    selected: {
      // reportType: null,
      customReportLink: null
    },
    jsonInBackend: {
      data: null
    }
    // allEcusSelected: false
  },
  mutations: {
    selected (state, payload) {
      state.selected[payload.propName] = payload.value
    },
    jsonInBackend (state, payload) {
      state.jsonInBackend[payload.propName] = payload.value
    },
    setDefaultState (state) {
      state.postReport = {
        error: false,
        loading: false,
        response: null
      }
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultSelectionState (state) {
      state.selected = {
        // reportType: null,
        customReportLink: null
      }
    }
  },
  getters: {
    // isAllEcusSelected: state => {
    //   return state.allEcusSelected
    // },
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit }, data) {
      commit('overwriteSelected', data)
    },
    updateSelection ({ commit }, payload) {
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default rootCauseAnalysis
